module.exports = __webpack_public_path__ + "media/file-icons/pdf-0a2e1207.gif";